import { UserAvatar } from "@components/avatar/UserAvatar";
import { EmptyCellValue } from "@design-system/DataGrid";
import { TaskAvatarLabel } from "./TaskAvatarLabel";
import { type TaskListTaskRow, toReadOnlyTaskCell } from "./taskRowCells";

const TaskCompletedBy = ({ task }: { task: TaskListTaskRow }) =>
    task.lastDoneBy ? (
        <TaskAvatarLabel
            avatar={<UserAvatar user={task.lastDoneBy} size="sm" aria-hidden />}
            label={task.lastDoneBy.name}
        />
    ) : (
        <EmptyCellValue empty="dash" />
    );

/** The Completed by column: who last marked the task done. */
export const TaskCompletedByCell = toReadOnlyTaskCell(TaskCompletedBy);
